import memepad from './memepad.json';
// import smallElon from "../../../images/smallElon.png";
import smallMepad from '../../../images/tribe_pool.png';

export const stakeIds = ['allocation', 'fixed'];

//Initial values of the stake, used when metamask is not connected.
//When metamask is connected, these values will update based on the contract.

export const stakingState = {
  tribeTokenContract: null,
  decimals: 18,
  tribeTokens: 0,
  allocation: {
    stakingContract: null,
    enabled: false,
    pendingReward: 0,
    stakedAmount: 0,
    totalStakingTokens: 0,
    bonusEndBlock: 0,
    freezeStartBlock: 0,
    freezeEndBlock: 0,
    withdrawFreezeEndBlock: 0,
    stakingUrl: memepad.prefix + memepad.allocation.stakingAddress + '#code', //Constant, not affected by metamask
    image: smallMepad, //Constant, not affected by metamask
    title: 'Allocation Staking', //Constant, not affected by metamask
    // subTitle: "Stake TRIBE, Earn TRIBE. Earn your Allocation", //Constant, not affected by metamask
    subTitle: (
      <span>
        Stake TRIBE, Earn TRIBE. <br /> Earn your Allocation
      </span>
    ), //Constant, not affected by metamask
    symbol: 'TRIBE', //Constant, not affected by metamask
    // isCompleted: false,
    beforeUnlockBtnText: 'Participate in the next launch',
  },
  fixed: {
    stakingContract: null,
    enabled: false,
    pendingReward: 0,
    stakedAmount: 0,
    rewardPerYear: 0,
    totalStakingTokens: 0,
    stakingUrl: memepad.prefix + memepad.fixed.stakingAddress + '#code', //Constant, not affected by metamask
    image: smallMepad, //Constant, not affected by metamask
    title: 'Fixed Term Staking', //Constant, not affected by metamask
    subTitle: (
      <span>
        Freeze your TRIBEs for 90 days <br /> & earn 2x Reward + allocation.
      </span>
    ), //Constant, not affected by metamask
    symbol: 'TRIBE', //Constant, not affected by metamask
    isCompleted: true, //This value got fetched from contract and became false eventually
    beforeUnlockBtnText: 'Freeze 90 days = 2x Reward + Allocation',
  },
};
